export default __webpack_public_path__ + "static/media/galaxy-gates.8fb1d702.mp4";